import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import { useEffect, useState } from "react";
import ReportScreen from "../../../../common/enums/ReportScreens";
import ReportFiltersComponent from "../ReportFiltersComponent";
import ReportFiltersLoading from "../ReportFiltersLoading";
import { ReportFilters } from "../../../../domain/models/report-filters";
import { HeadquarterWiseSalesStore } from "../../../../store/main/HeadquarterWiseSalesStore";
import moment from "moment";
import { FetchState } from "../../../../domain/models/fetch-state";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import HeadquarterWiseDetail from "./HeadquarterWiseDetail";
import FilterModal from "../FilterModal";

const HeadquarterWiseSalesDesktop = () => {
  const { userDetails, userRole, decodeToken } = CustomerDatabaseStore();
  const {
    HeadquarterWiseSalesData,
    fetchHeadquarterWiseSales,
    HeadquarterWiseSalesState,
  } = HeadquarterWiseSalesStore();

  const currentDate = new Date();
  const [open, setOpen] = useState<boolean>(false);
  const [allHq, setAllHq] = useState<string[]>([]);
  const [filteredData, setFilteredData] = useState<string[]>([]);
  useEffect(() => {
    decodeToken();
    fetchHeadquarterWiseSales(
      currentDate.getMonth() + 1,
      currentDate.getFullYear()
    );
  }, []);

  const filterData = (filters: ReportFilters) => {
    const month = moment(filters.date?.toString()).format("MM");
    const year = moment(filters.date?.toString()).format("yy");
    const payload = {
      zone_id: filters.zone[0],
      region_id: filters.region[0],
      area_id: filters.area[0],
      department_id: filters.department,
    };
    fetchHeadquarterWiseSales(month, year, payload);
  };
  useEffect(() => {
    if (HeadquarterWiseSalesState === FetchState.SUCCESS) {
      let arrHq: string[] = [];
      HeadquarterWiseSalesData.regions.forEach((region) => {
        region.areas.forEach((area) => {
          area.headquarters.forEach((hq) => {
            arrHq.push(hq.name);
          });
        });
      });
      setAllHq(arrHq);
    }
  }, [HeadquarterWiseSalesState]);
  const clearData = () => {
    fetchHeadquarterWiseSales(
      currentDate.getMonth() + 1,
      currentDate.getFullYear()
    );
  };

  const openFilterModal = () => {
    setOpen(true);
  };
  const filterDatas = (data: string[]) => {
    setFilteredData(data);
  };
  const closeFilterModal = () => {
    setOpen(false);
  };

  return (
    <>
      <Stack gap={3}>
        <Typography variant="h5" fontWeight={550}>
          Headquarter Wise Sales
        </Typography>
        {Object.keys(userDetails).length > 0 ? (
          <ReportFiltersComponent
            type={ReportScreen.STOCKIST_POB_VISIT_REPORT}
            successCallback={filterData}
            clearSuccessCallBack={clearData}
            userRole={userRole.role}
            userDetails={userDetails}
            gridColumns={23}
          />
        ) : (
          <ReportFiltersLoading />
        )}
        {HeadquarterWiseSalesState === FetchState.SUCCESS && (
          <>
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ bgcolor: "#edf6fc" }}>
                      <Stack direction={"row"} justifyContent={"space-between"}>
                        <Typography>Headquarter</Typography>
                        <Button onClick={openFilterModal}>
                          <FilterAltIcon fontSize="small" color="info" />
                        </Button>
                      </Stack>
                    </TableCell>
                    <TableCell sx={{ bgcolor: "#edf6fc" }}>
                      Total Customers
                    </TableCell>
                    <TableCell sx={{ bgcolor: "#edf6fc" }}>Visits</TableCell>
                    <TableCell sx={{ bgcolor: "#edf6fc" }}>
                      Total Productive Order
                    </TableCell>
                    <TableCell sx={{ bgcolor: "#edf6fc" }}>
                      Total Amount
                    </TableCell>
                    <TableCell sx={{ bgcolor: "#edf6fc" }}>Target</TableCell>
                    <TableCell sx={{ bgcolor: "#edf6fc" }}>
                      No. of Customers with No Primary Sales
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {HeadquarterWiseSalesData.regions.map((region) => (
                    <>
                      {region.areas.map((area) => (
                        <>
                          {area.headquarters.map((hq) => {
                            if (filteredData.length === 0) {
                              return <HeadquarterWiseDetail customer={hq} />;
                            } else {
                              if (filteredData.includes(hq.name)) {
                                return <HeadquarterWiseDetail customer={hq} />;
                              }
                            }
                          })}
                        </>
                      ))}
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </Stack>
      {open && (
        <FilterModal
          open={open}
          handleClose={closeFilterModal}
          successCallback={filterDatas}
          data={allHq}
          filterData={filteredData}
          name="Headquarter"
        />
      )}
    </>
  );
};

export default HeadquarterWiseSalesDesktop;
